import MobileNavigation from './mobile-navigation';
import SideMenu from './side-menu';
import Learn from './dropdown/learn';
import Products from './dropdown/products';
import Kits from './dropdown/kits';
import LimitedEdition from './dropdown/limited-edition';
import Support from './support';

export default class ShopNavigation {
  initializeEventListeners = () => {
    (new MobileNavigation()).initializeEventListeners();
    (new SideMenu()).initializeEventListeners();
    (new Learn()).initializeEventListeners();
    (new Products()).initializeEventListeners();
    (new Kits()).initializeEventListeners();
    (new LimitedEdition()).initializeEventListeners();
    (new Support()).initializeEventListeners();
  };
}
